// Mock data pour le site de l'association APELGP

export const associationInfo = {
  name: "APELGP",
  fullName: "APELGP",
  tagline: "Créer du lien social à travers les loisirs et la culture",
  description: "APELGP est une association dédiée à la culture, au patrimoine, à la gastronomie, aux loisirs, aux événements et aux séjours culturels. Nous développons le lien social par des actions de proximité : ateliers culturels et culinaires, sorties, visites, rencontres, événements et escapades à la découverte de nouvelles destinations.",
  members: "3000+",
  founded: "2011",
  foundedDate: "03/01/2011",
  volunteers: "10+",
  address: "Quartier les 3 fonds",
  city: "13124 Peypin",
  contactCta: "Contactez-nous via le formulaire de contact",
  siret: "529 404 873 00018",
  rna: "W133015730"
};

export const mission = [
  {
    number: "01",
    title: "Culture & Patrimoine",
    description: "Visites culturelles, patrimoine local et régional, musées, expositions, concerts et découverte de savoir-faire pour transmettre et valoriser notre héritage commun."
  },
  {
    number: "02",
    title: "Gastronomie",
    description: "Ateliers culinaires, gastronomie régionale, patrimoine gastronomique, rencontres autour des produits et savoir-faire, et dégustations conviviales."
  },
  {
    number: "03",
    title: "Sorties & Loisirs",
    description: "Sorties culturelles, activités de groupe, journées thématiques, rencontres et loisirs favorisant le lien social et la convivialité entre nos membres."
  },
  {
    number: "04",
    title: "Séjours Culturels",
    description: "Escapades culturelles, week-ends patrimoine, séjours découverte et visites de destinations mêlant gastronomie, patrimoine régional et rencontres."
  }
];

export const upcomingEvents = [
  {
    id: 1,
    title: "Atelier cuisine du terroir",
    category: "Gastronomie",
    date: "",
    time: "",
    location: "Peypin",
    image: "https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=800&q=80",
    description: "Découverte des recettes traditionnelles et savoir-faire culinaires régionaux avec un chef invité."
  },
  {
    id: 2,
    title: "Visite de patrimoine historique",
    category: "Culture & Patrimoine",
    date: "",
    time: "",
    location: "Marseille",
    image: "https://images.unsplash.com/photo-1566838217578-1903568a76d9?w=800&q=80",
    description: "Exploration commentée du patrimoine historique et architectural de la région."
  },
  {
    id: 3,
    title: "Découverte gastronomique",
    category: "Gastronomie",
    date: "",
    time: "",
    location: "Peypin",
    image: "https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?w=800&q=80",
    description: "Rencontre autour des produits du terroir, dégustation et échange avec des producteurs locaux."
  },
  {
    id: 4,
    title: "Atelier artisanal",
    category: "Savoir-faire",
    date: "",
    time: "",
    location: "Peypin",
    image: "https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?w=800&q=80",
    description: "Initiation à un savoir-faire artisanal avec des artisans passionnés pour transmettre leur passion."
  },
  {
    id: 5,
    title: "Escapade & séjour culturel",
    category: "Séjour",
    date: "",
    time: "",
    location: "Provence",
    image: "https://images.unsplash.com/photo-1488459716781-31db52582fe9?w=800&q=80",
    description: "Séjour découverte mêlant patrimoine, gastronomie régionale et rencontres avec des partenaires locaux."
  }
];

export const testimonials = [
  {
    name: "Marie Dubois",
    role: "Membre depuis 2021",
    text: "Une association formidable qui permet de découvrir notre patrimoine tout en créant du lien social. Les ateliers sont toujours enrichissants !"
  },
  {
    name: "Jean Martin",
    role: "Membre depuis 2020",
    text: "J'ai redécouvert ma passion pour la cuisine traditionnelle grâce aux ateliers culinaires. L'ambiance est conviviale et chaleureuse."
  },
  {
    name: "Sophie Laurent",
    role: "Membre depuis 2022",
    text: "Les événements culturels organisés sont d'une qualité exceptionnelle. C'est un réel plaisir de partager ces moments avec d'autres passionnés."
  }
];

export const stats = [
  { label: "Personnes dans notre communauté", value: "3000+" },
  { label: "Bénévoles engagés", value: "10+" },
  { label: "Depuis", value: "2011" },
  { label: "Activités toute l'année", value: "✓" }
];

export const legalInfo = {
  associationName: "APELGP",
  sigle: "APELGP",
  siegeSocial: "Quartier les 3 fonds, 13124 Peypin",
  siret: "529 404 873 00018",
  rna: "W133015730",
  dateCreation: "03/01/2011",
  formeJuridique: "Association déclarée – loi du 1er juillet 1901",
  objet: "APELGP a pour objet la promotion, la transmission et la valorisation de la culture, notamment du patrimoine culturel et gastronomique, ainsi que le développement du lien social par des actions de proximité. Dans ce cadre, l'association peut notamment organiser des ateliers culturels et culinaires, des cours, démonstrations, rencontres, événements, sorties, actions de médiation et de sensibilisation liées au patrimoine culturel et gastronomique.",
  directeurPublication: "Le/la Président(e) en exercice",
  hebergeur: {
    nom: "Hébergeur du site",
    adresse: "À renseigner par l'association selon le prestataire retenu"
  }
};